import { render, staticRenderFns } from "./manuSpectaculars.vue?vue&type=template&id=a6f08754&scoped=true"
import script from "./manuSpectaculars.vue?vue&type=script&lang=js"
export * from "./manuSpectaculars.vue?vue&type=script&lang=js"
import style0 from "./manuSpectaculars.vue?vue&type=style&index=0&id=a6f08754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f08754",
  null
  
)

export default component.exports